import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatBadgeModule, MatMenuModule, MatIconModule],
    template: `

    <ng-container>
        @for (file of files(); track file; let index = $index) {
            @if(index==0){
                <div mat-button [matBadge]="files().length > 1 ? '+' + (files().length - 1) : null" matBadgePosition="above after" matBadgeColor="accent" [matMenuTriggerFor]="menu" class="m-2 p-1" style="width: 50px; height: 50px;cursor:pointer;">
                    @if(!file.endsWith('.pdf')){
                        <img src="{{file}}" width="50" height="50" onerror="this.src='./../../assets/img/default.jpg'" class="rounded imgBTN">
                    }
                    @if(file.endsWith('.pdf')){
                        <button mat-button class="secondary-gray-button" style="width:75px">
                            PDF
                        </button>
                    }
                </div>
            }
        }
    </ng-container>

    <mat-menu #menu="matMenu">
        <div class="d-flex p-1">
            @for (file of files(); track file; let index = $index) {
                <div class="p-2">
                    @if(file.endsWith('.pdf')){
                        <a href="{{file}}" class="pdf-title" target="_blank">
                            <div><mat-icon class="material-symbols-outlined">open_in_new</mat-icon>{{extractNameFromUrl(file)}}</div>
                        </a>
                    }
                    @if(!file.endsWith('.pdf')){
                        <a href="{{file}}" target="_blank" style="cursor:zoom-in;">
                            <img src="{{file}}" width="100" height="100" onerror="this.src='./../../assets/img/default.jpg'" class="image-hover rounded" style="object-fit: cover;">
                        </a>
                    }
                </div>
            }
        </div>
    </mat-menu>
    
    `
})

// <button (click)="buttonClicked()">
//         file    
//     </button>
export class ReportsListItemMediaDisplay implements ICellRendererAngularComp {
    data: any;
    files = signal<string[]>([]);
    filesLength = signal<number>(0)
    agInit(params: ICellRendererParams): void {
        this.data = params.value;
        this.refresh(params);
    }
    refresh(params: ICellRendererParams) {
        this.files.set(params.value ?? []);
        this.filesLength.set(params.value?.length ?? undefined)
        return true;
    }

    extractNameFromUrl(url: string): string {
        const pattern = /([^/]+)\.pdf$/;
        const match = url.match(pattern);
        return match ? match[1] : '';
      }
}